export * from "./StaticFooter"


// WEBPACK FOOTER //
// ./src/common/footer/index.ts